module.exports = __webpack_public_path__ + "img/hmpg-bluepeople.e381219b.svg";